import { useMemo } from 'react';

export type SteamImageSize = '100fx100f' | '200fx200f' | '360fx360f' | '500fx500f' | string;

/** Formats a Steam CDN image URL to append specified size dimensions. */
export const formatSteamImageUrl = (url: string | null | undefined, size: SteamImageSize = '360fx360f'): string => {
    if (!url) return '';
    const trimmedUrl = url.trim().replace(/\/+$/, '');
    if (/\/\d+f(?:x\d+f)?$/.test(trimmedUrl)) {
        return trimmedUrl;
    }
    return `${trimmedUrl}/${size}`;
};

/** Hook providing memoized Steam CDN image URL with size formatting. */
export const useSteamImageUrl = (url: string | null | undefined, size: SteamImageSize = '360fx360f'): string => {
    return useMemo(() => formatSteamImageUrl(url, size), [url, size]);
};